<template>
    <div id="graph-wrapper" class="relative" ref="graph_wrapper"></div>
</template>

<script>
import {Graph} from 'vivagraphjs';
export default {
    data() {
        return {
            graph: null,
            renderer: null,
            layout: null,
            graphics: null,
            labels: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.initGraph();
                this.renderGraph();
            }, 300); 
        });
        console.log('graph mounted');
    },

    computed: {
        notes() {
            return Object.values(this.$store.getters.notes).map(note => {
                note.links =this.linksForNote(note);
                return note; 
            }).sort((a, b) => {
                if (a.links.length > b.links.length) return 1;
                else if (a.links.length < b.links.length) return -1;
                else return 0;
            }).reverse();
        },
    },

    methods: {
        initGraph() {
            this.graph = Graph.graph();
            this.layout = Graph.Layout.forceDirected(this.graph, {
                springLength : 250,
                springCoeff : 0.001,
                dragCoeff : 0.05,
                gravity : -0.5,
                theta: 1
            });
            this.graphics = Graph.View.webglGraphics();
            this.graphics.placeNode(this.positionLabel);
            this.renderer = Graph.View.renderer(this.graph, {
                layout: this.layout,
                container: this.$refs.graph_wrapper,
                graphics: this.graphics,
                interactive: true
            });
            let events = Graph.webglInputEvents(this.graphics, this.graph);
            events.dblClick((node) => {
                this.onClickNode(node);
            })
        },
        renderGraph() {
            this.generateNodes();
            this.labels = this.generateNodeLabels();

            this.renderer.run();
        },
        onClickNode(node) {
            this.$router.push(`/${node.data.workspace}/notes/${node.data.slug}`)
        },
        linksForNote(note) {
            let current_note = note;
            let getters = this.$store.getters;
            if (!current_note) return [];

            let notes = getters.notes;
            if (!notes) return [];

            return Object.values(notes).reduce((links, note) => {
                if (note.slug === current_note.slug) return links;

                let index = current_note.text.indexOf(note.title);

                if (index > -1) links.push(note);
                
                if (note.aliases) note.aliases.forEach((alias, alias_index) => {
                    let is_match = current_note.text.indexOf(alias);
                    if (is_match > -1) links.push({...note, alias_index})
                })

                return links;
            }, []).sort((a, b) => {
                if (a.title.length === b.title.length) return 0;
                if (a.title.length < b.title.length) return 1
                else return -1;
            });
        },
        generateNodes() {
            this.notes.forEach(note => {
               
                this.graph.addNode(note.slug, note);
                note.links.reverse().forEach(link => {
                    this.graph.addLink(note.slug, link.slug);
                });
            });
        },
        generateNodeLabels() {
            let labels = Object.create(null);
            this.graph.forEachNode((node) => {
                let label = document.createElement('span');
                label.classList.add('node-label');
                label.innerText = node.data.title;
                label.ondblclick=() => {this.onClickNode(node)};
                labels[node.id] = label;
                this.$refs.graph_wrapper.appendChild(label);
            });
            
            // NOTE: If your graph changes over time you will need to
            // monitor graph changes and update DOM elements accordingly
            return labels;
        },
        positionLabel(ui, pos) {  
            if (!ui) return;
            // This callback is called by the renderer before it updates
            // node coordinate. We can use it to update corresponding DOM
            // label position;

            // we create a copy of layout position
            let domPos = {
                x: pos.x,
                y: pos.y
            };
            // And ask graphics to transform it to DOM coordinates:
            this.graphics.transformGraphToClientCoordinates(domPos);

            // then move corresponding dom label to its own position:
            let nodeId = ui.node.id;
            let labelStyle = this.labels[nodeId].style;

            labelStyle.left = (domPos.x - 5  ) + 'px';
            labelStyle.top  = (domPos.y - 25 ) + 'px';  
        }
    }
}
</script>
<style lang="sass" scoped>
    #graph-wrapper
        width: 100%
        height: 100%
        position: relative
</style>
<style lang="sass">
    .node-label
        position: absolute
        cursor: pointer
</style>